module.exports = __webpack_public_path__ + "assets/img/title-e5dcc776.png";